import Service from '../../Service';
import {http} from '../../config';

export default class MonitoramentoAtividadeService extends Service{

    constructor(){
        super('MonitoramentoAtividade');
    }

    EnviarDocumento(monitoramentoAtividadeId, monitoramentoAtividadeItemId, nome, arquivo){
        let bodyFormData = new FormData();
        bodyFormData.append('arquivo', new Blob([arquivo], { type: 'application/pdf' }));

        return http.post(`${this.getNomeControle()}/${monitoramentoAtividadeId}/documento`, bodyFormData, {
            headers: {'Content-Type': 'multipart/form-data' },
            params: {
                monitoramentoAtividadeItemId: monitoramentoAtividadeItemId,
                nome: nome
            }
        });
    }

    DownloadDocumento(monitoramentoAtividadeId, nome){
        return http.get(`${this.getNomeControle()}/${monitoramentoAtividadeId}/documento`, {
            responseType: 'blob',
            params: {
                nome: nome
            }
        }).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nome);
            document.body.appendChild(link);
            link.click();
        });
    }

    DeletarDocumento(monitoramentoAtividadeId, monitoramentoAtividadeItemId, nome){
        return http.delete(`${this.getNomeControle()}/${monitoramentoAtividadeId}/documento`, {
            params: {
                monitoramentoAtividadeItemId: monitoramentoAtividadeItemId,
                nome: nome
            }
        });
    }
  
}